import { render, staticRenderFns } from "./ProductReviewForm.vue?vue&type=template&id=7b9c3210&"
import script from "./ProductReviewForm.vue?vue&type=script&lang=js&"
export * from "./ProductReviewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b9c3210')) {
      api.createRecord('7b9c3210', component.options)
    } else {
      api.reload('7b9c3210', component.options)
    }
    module.hot.accept("./ProductReviewForm.vue?vue&type=template&id=7b9c3210&", function () {
      api.rerender('7b9c3210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/ProductReviewForm.vue"
export default component.exports